(function () {
  const STYLE_URLS = {
    positron: 'https://tiles.openfreemap.org/styles/positron',
    liberty: 'https://tiles.openfreemap.org/styles/liberty',
    bright: 'https://tiles.openfreemap.org/styles/bright',
    fiord: 'https://tiles.openfreemap.org/styles/fiord',
    dark: 'https://tiles.openfreemap.org/styles/dark',
    '3d': 'https://tiles.openfreemap.org/styles/3d'
  };

  function waitForMapLibre(callback) {
    if (window.maplibregl) {
      callback();
      return;
    }

    let tries = 0;
    const timer = window.setInterval(function () {
      tries += 1;
      if (window.maplibregl) {
        window.clearInterval(timer);
        callback();
      }
      if (tries > 80) window.clearInterval(timer);
    }, 100);
  }

  function toNumber(value, fallback) {
    const parsed = Number(String(value || '').replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function distanceKm(lat1, lng1, lat2, lng2) {
    const radius = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);

    return radius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function initSection(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const mapNode = section.querySelector('[data-fg-map]');
    const listNode = section.querySelector('[data-fg-store-list]');
    const searchInput = section.querySelector('[data-fg-store-search]');
    const locationButton = section.querySelector('[data-fg-use-location]');
    const noticeNode = section.querySelector('[data-fg-store-notice]');
    const selectedCardNode = section.querySelector('[data-fg-selected-card]');
    const markerLogo = section.dataset.markerLogo || '';
    const mapButtonLabel = section.dataset.mapButtonLabel || 'Ottieni indicazioni';
    const selectedLabel = section.dataset.selectedLabel || 'Boutique selezionata';

    let userMarker = null;
    let activeStore = null;

    if (!mapNode || !listNode || !window.maplibregl) return;

    function openExternalMap(url) {
      if (!url) return;
      const opened = window.open(url, '_blank', 'noopener,noreferrer');
      if (opened) opened.opener = null;
    }

    section.addEventListener('click', function (event) {
      const link = event.target && event.target.closest ? event.target.closest('[data-fg-external-map-link]') : null;
      if (!link) return;

      const url = link.getAttribute('href');
      if (!url) return;

      event.preventDefault();
      openExternalMap(url);
    });

    const cards = Array.prototype.slice.call(section.querySelectorAll('[data-fg-store-card]'));
    const stores = cards.map(function (card, index) {
      return {
        index: index,
        card: card,
        name: card.dataset.name || '',
        address: card.dataset.address || '',
        city: card.dataset.city || '',
        cap: card.dataset.cap || '',
        province: card.dataset.province || '',
        country: card.dataset.country || '',
        phone: card.dataset.phone || '',
        email: card.dataset.email || '',
        hours: card.dataset.hours || '',
        lat: toNumber(card.dataset.lat, null),
        lng: toNumber(card.dataset.lng, null),
        mapUrl: card.dataset.mapUrl || '',
        order: toNumber(card.dataset.order, index + 1),
        distance: null
      };
    }).filter(function (store) {
      return Number.isFinite(store.lat) && Number.isFinite(store.lng);
    }).sort(function (a, b) {
      return a.order - b.order;
    });

    stores.forEach(function (store) {
      listNode.appendChild(store.card);
    });

    const defaultLat = toNumber(section.dataset.defaultLat, stores[0] ? stores[0].lat : 41.9028);
    const defaultLng = toNumber(section.dataset.defaultLng, stores[0] ? stores[0].lng : 12.4964);
    const defaultZoom = toNumber(section.dataset.defaultZoom, 5);
    const styleKey = section.dataset.mapStyle || 'positron';

    const map = new maplibregl.Map({
      container: mapNode,
      style: STYLE_URLS[styleKey] || STYLE_URLS.positron,
      center: [defaultLng, defaultLat],
      zoom: defaultZoom,
      attributionControl: true
    });

    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');

    const markers = [];
    const bounds = new maplibregl.LngLatBounds();

    function actionLinks(store, linkClass) {
      const links = [];

      if (store.mapUrl) {
        links.push('<a class="' + linkClass + '" href="' + escapeHtml(store.mapUrl) + '" target="_blank" rel="noopener noreferrer" data-fg-external-map-link>' + escapeHtml(mapButtonLabel) + '</a>');
      }

      if (store.phone) {
        links.push('<a class="' + linkClass + '" href="tel:' + escapeHtml(store.phone.replace(/\s/g, '')) + '">Chiama</a>');
      }

      return links.join('');
    }

    function addressHtml(store) {
      const line2 = [store.cap, store.city].filter(Boolean).join(' ');
      const parts = [store.address, line2, store.country].filter(Boolean);
      return escapeHtml(parts.join('\n')).replace(/\n/g, '<br>');
    }

    function renderSelectedCard(store) {
      if (!selectedCardNode || !store) return;

      selectedCardNode.classList.remove('is-ready');
      const contact = [store.phone].filter(Boolean).map(escapeHtml).join('<br>');

      selectedCardNode.innerHTML =
        '<span class="fg-selected-card__label">' + escapeHtml(selectedLabel) + '</span>' +
        '<strong class="fg-selected-card__title">' + escapeHtml(store.name) + '</strong>' +
        '<span class="fg-selected-card__text">' + addressHtml(store) + (contact ? '<br>' + contact : '') + '</span>' +
        '<div class="fg-selected-card__actions">' + actionLinks(store, 'fg-selected-card__action') + '</div>';

      window.requestAnimationFrame(function () {
        selectedCardNode.classList.add('is-ready');
      });
    }

    function setActive(store, options) {
      if (!store) return;

      options = options || {};
      activeStore = store;

      stores.forEach(function (item) {
        item.card.classList.toggle('is-active', item.index === store.index);
      });

      markers.forEach(function (item) {
        item.el.classList.toggle('is-active', item.store.index === store.index);
      });

      renderSelectedCard(store);

      if (options.fly) {
        map.flyTo({
          center: [store.lng, store.lat],
          zoom: Math.max(map.getZoom(), 13),
          essential: true,
          duration: 700
        });
      }

      if (options.scrollCard && store.card && listNode) {
        store.card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    stores.forEach(function (store) {
      const el = document.createElement('div');
      el.className = 'fg-map-marker';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', store.name);
      el.innerHTML = markerLogo ? '<img src="' + escapeHtml(markerLogo) + '" alt="" loading="lazy">' : '<span>•</span>';

      const marker = new maplibregl.Marker({ element: el, anchor: 'bottom' })
        .setLngLat([store.lng, store.lat])
        .addTo(map);

      el.addEventListener('click', function () {
        setActive(store, { fly: true, scrollCard: true });
      });

      el.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setActive(store, { fly: true, scrollCard: true });
        }
      });

      markers.push({ store: store, marker: marker, el: el });
      bounds.extend([store.lng, store.lat]);

      const focusButton = store.card.querySelector('[data-fg-store-focus]');
      if (focusButton) {
        focusButton.addEventListener('click', function () {
          setActive(store, { fly: true, scrollCard: false });
        });
      }
    });

    map.on('load', function () {
      map.resize();

      if (stores.length > 1) {
        map.fitBounds(bounds, { padding: 70, maxZoom: 12, duration: 0 });
      } else if (stores.length === 1) {
        map.setCenter([stores[0].lng, stores[0].lat]);
        map.setZoom(13);
      }

      if (stores[0]) setActive(stores[0], { fly: false, scrollCard: false });
    });

    function applySearch() {
      const query = (searchInput ? searchInput.value : '').trim().toLowerCase();
      let visibleCount = 0;
      const visibleBounds = new maplibregl.LngLatBounds();

      stores.forEach(function (store) {
        const haystack = [store.name, store.address, store.city, store.cap, store.province, store.country].join(' ').toLowerCase();
        const visible = !query || haystack.indexOf(query) !== -1;

        store.card.hidden = !visible;

        const markerItem = markers.find(function (item) {
          return item.store.index === store.index;
        });

        if (markerItem) markerItem.el.style.display = visible ? '' : 'none';

        if (visible) {
          visibleCount += 1;
          visibleBounds.extend([store.lng, store.lat]);
        }
      });

      if (noticeNode && visibleCount === 0) noticeNode.textContent = 'Nessun negozio trovato per questa ricerca.';
      if (noticeNode && visibleCount > 0 && query) noticeNode.textContent = '';

      if (visibleCount > 0 && query) {
        map.fitBounds(visibleBounds, { padding: 80, maxZoom: 13, duration: 600 });
      }
    }

    function sortByDistance(position) {
      stores.forEach(function (store) {
        store.distance = distanceKm(position.lat, position.lng, store.lat, store.lng);

        const distanceNode = store.card.querySelector('[data-fg-store-distance]');
        if (distanceNode) {
          distanceNode.textContent = store.distance < 1
            ? Math.round(store.distance * 1000) + ' m'
            : store.distance.toFixed(1).replace('.', ',') + ' km';
        }
      });

      stores.sort(function (a, b) {
        return a.distance - b.distance;
      });

      stores.forEach(function (store) {
        listNode.appendChild(store.card);
      });

      if (userMarker && userMarker.remove) userMarker.remove();

      const userEl = document.createElement('div');
      userEl.className = 'fg-map-marker fg-map-marker--user';
      userMarker = new maplibregl.Marker({ element: userEl, anchor: 'center' })
        .setLngLat([position.lng, position.lat])
        .addTo(map);

      const nearest = stores[0];

      if (nearest) {
        setActive(nearest, { fly: false, scrollCard: true });

        const distance = nearest.distance || 0;

        if (distance <= 50) {
          const cityBounds = new maplibregl.LngLatBounds();
          cityBounds.extend([position.lng, position.lat]);
          cityBounds.extend([nearest.lng, nearest.lat]);

          map.fitBounds(cityBounds, {
            padding: { top: 90, right: 90, bottom: 90, left: 90 },
            maxZoom: 15,
            duration: 850
          });
        } else {
          map.flyTo({
            center: [nearest.lng, nearest.lat],
            zoom: 13,
            essential: true,
            duration: 850
          });
        }

        if (noticeNode) {
          noticeNode.textContent = 'Boutique più vicina: ' + nearest.name + ' · ' + nearest.distance.toFixed(1).replace('.', ',') + ' km da te.';
        }
      }

      applySearch();
    }

    if (searchInput) {
      searchInput.addEventListener('input', applySearch);
    }

    if (locationButton) {
      locationButton.addEventListener('click', function () {
        if (!navigator.geolocation) {
          if (noticeNode) noticeNode.textContent = 'Geolocalizzazione non disponibile su questo browser.';
          return;
        }

        if (noticeNode) noticeNode.textContent = 'Richiesta posizione in corso...';

        navigator.geolocation.getCurrentPosition(
          function (pos) {
            sortByDistance({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude
            });
          },
          function () {
            if (noticeNode) noticeNode.textContent = 'Permesso posizione non concesso. Puoi cercare per città o CAP.';
          },
          {
            enableHighAccuracy: true,
            timeout: 12000,
            maximumAge: 60000
          }
        );
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.fg-store-locator').forEach(function (section) {
      initSection(section);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    const reloaded = event.target && event.target.querySelector && event.target.querySelector('.fg-store-locator');
    if (reloaded) initSection(reloaded);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForMapLibre(initAll);
    });
  } else {
    waitForMapLibre(initAll);
  }
})();
